import { useEffect, useState } from 'react';

type Image = {
    id: string;
    url: string;
};

function useImagePreloader(images: Image[]) {
    const [imageIdsAlreadyPreloaded, setImageIdsAlreadyPreloaded] = useState<string[]>([]);

    useEffect(() => {
        images.forEach((image) => {
            if (imageIdsAlreadyPreloaded.indexOf(image.id) === -1) {
                new Image().src = image.url;
                imageIdsAlreadyPreloaded.push(image.id);
                setImageIdsAlreadyPreloaded(imageIdsAlreadyPreloaded);
            }
        });

        return () => {
            setImageIdsAlreadyPreloaded([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [images, setImageIdsAlreadyPreloaded]);
}

export default useImagePreloader;
